import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

interface ArticlePost {
  id: number;
  title: string;
  image: string;
  slug?: string;
}
@Component({
  selector: 'app-about-ceo',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './about-ceo.component.html',
  styleUrl: './about-ceo.component.scss'
})
export class AboutCeoComponent implements OnInit, OnDestroy {

  private jsonLdScript: any;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

injectSchemaMarkup(): void {
    const ceoSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/about-ceo",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/about-ceo",
          "name": "Empowering Digital Transformation — Kube G, CEO of Kalpita Technologies",
          "description": "In a conversation with QNA India, Kube G, Co-founder and CEO of Kalpita Technologies, shares his vision for building a technology-driven enterprise through cloud, analytics, and engineering excellence.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".softwaredev-heading",
              ".takeaways-section .takeaway-item p",
              ".section-title"
            ]
          },
          "datePublished": "2025-01-15",
          "dateModified": "2025-01-15",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/about-ceo#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews", "name": "News" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/about-ceo", "name": "Empowering Digital Transformation — About CEO" } }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Empowering Digital Transformation: In a Conversation with Kube G, Co-founder & CEO, Kalpita Technologies",
          "alternativeHeadline": "How Kube G Built Kalpita Technologies Through Vision, Innovation, and People-First Culture",
          "articleBody": "In an exclusive conversation with QNA India, Kube G, Co-founder and CEO of Kalpita Technologies, shares his vision behind building a technology-driven enterprise... with offices in Austin, Texas and Bengaluru, India.",
          "author": { "@type": "Organization", "name": "QNA India" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-01-15"
        },
        {
          "@type": "HowTo",
          "name": "How to Build a Technology-Driven Enterprise",
          "description": "Step-by-step guide to building and scaling a global IT services company based on Kube G's leadership principles.",
          "step": [
            { "@type": "HowToStep", "name": "Bridge Business and Technology", "text": "Start with a mission to bridge the gap between business needs and tech solutions." },
            { "@type": "HowToStep", "name": "Scale Strategically", "text": "Expand globally by building service excellence in cloud, analytics, and engineering." },
            { "@type": "HowToStep", "name": "Differentiate via Agility", "text": "Invest in R&D and agile delivery to stand out in competitive markets." },
            { "@type": "HowToStep", "name": "Foster People-First Culture", "text": "Focus on employee well-being and continuous learning to drive long-term innovation." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Who is Kube G and what is his role at Kalpita Technologies?",
              "acceptedAnswer": { "@type": "Answer", "text": "Kube G is the Co-founder and CEO of Kalpita Technologies, who built the firm from a startup into a global enterprise service provider." }
            },
            {
              "@type": "Question",
              "name": "What is his vision for the company?",
              "acceptedAnswer": { "@type": "Answer", "text": "His vision is to bridge the gap between business needs and engineering excellence while maintaining a people-first culture." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(ceoSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  articles: ArticlePost[] = [
    {
      id: 1,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-one.webp'
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-two.webp'
    },
    {
      id: 3,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-three.webp'
    },
    {
      id: 4,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-four.webp'
    },
    {
      id: 5,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-five.webp'
    },
    {
      id: 6,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-six.webp'
    },
    {
      id: 7,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-seven.webp'
    },
    {
      id: 8,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-eight.webp'
    }
  ];
  onArticleClick(article: ArticlePost): void {
    console.log('Article clicked:', article);
    // Handle navigation to article detail page
  }

  trackByArticle(index: number, article: ArticlePost): number {
    return article.id;
  }
}
